const HEX_PATTERN = /^#?([0-9a-f]{6})$/i;

const toRgb = (hex) => {
  const value = String(hex || '#000000').replace('#', '');
  const full = value.length === 3 ? value.replace(/./g, (char) => char + char) : value.slice(0, 6);
  const int = parseInt(full, 16) || 0;
  return { r: (int >> 16) & 255, g: (int >> 8) & 255, b: int & 255 };
};

export const withAlpha = (hex, alpha) => {
  const { r, g, b } = toRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const normalizeHex = (value) => {
  const match = HEX_PATTERN.exec(String(value || '').trim());
  return match ? `#${match[1].toUpperCase()}` : null;
};

export const isLightColor = (hex) => {
  const { r, g, b } = toRgb(hex);
  return 0.299 * r + 0.587 * g + 0.114 * b > 160;
};
